import {Action} from '@ngrx/store';
import {Application} from '../models/application.model';
import {DataSourceType} from '../models/data-source-type.model';
import {DataSourceConfig} from '../models/data-source-config.model';
import {Integration} from '../models/integration.model';
import {IntegrationTask} from '../models/integration-task.model';
import {IntegrationState} from '../models/integration-state.model';
import {IntegrationMode} from '../models/integration-mode.model';
import {OrganizationsMapping} from '../models/organizationsMapping.model';
import {FTPConfig} from '../models/ftp-config';
import {OrgMapping} from '../models/orgMapping.model';
import {FTPUser} from '../models/ftp-user.model';
import {ProcessConfig} from '../models/process-config.model';
import {FileUploader} from 'ng2-file-upload';
import {MetadataModel} from '@app/core/model/filtering/metadata-model';
import {EntityFilterModel} from '@app/core/model/filtering/entity-filter-model';
import {DomainOfUniqueness} from '../models/domain-of-uniqueness.model';
import {Spinner} from '@app/core/service/spinner.service';
import {BehaviorSubject} from 'rxjs';
import {MappingRule} from '@app/views/admin/application-settings/models/mapping-rules.model';
import {DictionaryModel} from '@app/views/admin/application-settings/models/dictionary.model';
import {SavePolicyModel} from '@app/views/admin/privacy-policy/privacy-policy.service';
import {RosterAccessProgress} from '@app/views/admin/application-settings/models/roster-access-progress.model';
import {QwiklabsCourse} from '@app/views/admin/application-settings/models/qwiklabs-course.model';
import {Claim} from '@app/views/common/dialog-announcement/announcement.service';
import {MasterFieldsMergingRule, MasterFieldsModel} from '@app/views/admin/application-settings/models/master-fields.model';
import {UserPermissionModel} from '@app/views/admin/application-settings/models/user-permission.model';
import {ViewContainerRef} from '@angular/core';
import {GoogleClassroomDataSourceOptions} from '@app/views/admin/application-settings/models/google-clasroom-ds-options.model';
import {SharedPoolResponseData} from '@app/core/model/shared-pool.model';
import {FEATURE_TOGGLE_LEVEL, FeatureToggleModel} from '@app/views/common/feature-toggles/featue-toggle.model';
import {FormControl} from '@angular/forms';
import {Webhook} from '@app/views/admin/application-settings/models/provisioning.model';
import {
    PIIShieldEntityAttributes
} from '@app/views/admin/application-settings/components/basic/pii-shield-level-info/entity-attributes/pii-shield-entities-attributes.component';

export const GET_APPLICATION = 'GET_APPLICATION';
export const ASSIGN_APPLICATION = 'ASSIGN_APPLICATION';
export const CREATE_OR_UPDATE_APPLICATION = 'CREATE_OR_UPDATE_APPLICATION';
export const GET_DEFAULT_APPLICATIONS = 'GET_DEFAULT_APPLICATIONS';
export const SET_DEFAULT_APPLICATIONS = 'SET_DEFAULT_APPLICATIONS';
export const SET_PROVIDER_ALLOWED_APPLICATIONS = 'SET_PROVIDER_ALLOWED_APPLICATIONS';
export const SET_VENDOR_ALLOWED_APPLICATIONS = 'SET_VENDOR_ALLOWED_APPLICATIONS';
export const SET_USER_PERMISSIONS = 'SET_USER_PERMISSIONS';
export const GET_FTP_CONFIG = 'GET_FTP_CONFIG';
export const SET_FTP_CONFIG = 'SET_FTP_CONFIG';
export const ASSIGN_FTP_CONFIG = 'ASSIGN_FTP_CONFIG';
export const CREATE_FTP_USER = 'CREATE_FTP_USER';
export const EDIT_FTP_USER = 'EDIT_FTP_USER';
export const DELETE_FTP_USER = 'DELETE_FTP_USER';
export const GET_RANK__ONE_DISTRICT_LIST = 'GET_RANK__ONE_DISTRICT_LIST';
export const ASSIGN_DATA_SOURCE_CONFIG = 'ASSIGN_DATA_SOURCE_CONFIG';
export const GET_DATA_SOURCE_CONFIG = 'GET_DATA_SOURCE_CONFIG';
export const UPDATE_DATA_SOURCE_CONFIG = 'UPDATE_DATA_SOURCE_CONFIG';
export const ASSIGN_MAPPING_RULES_ARCHIVE_OU = 'ASSIGN_MAPPING_RULES_ARCHIVE_OU';
export const SAVE_MAPPING_RULES_ARCHIVE_OU = 'SAVE_MAPPING_RULES_ARCHIVE_OU';
export const CREATE_SHARED_POOL = 'CREATE_SHARED_POOL';
export const GET_SHARED_POOLS_BY_APP = 'GET_SHARED_POOLS_BY_APP';
export const CHECK_EXISTANCE_OF_POWER_SCHOOL_PLUGIN = 'CHECK_EXISTANCE_OF_POWER_SCHOOL_PLUGIN';
export const CREATE_DATA_SOURCE_CONFIG_AND_INTEGRATION = 'CREATE_DATA_SOURCE_CONFIG_AND_INTEGRATION';
export const CREATE_DATA_SOURCE_CONFIG_WITHOUT_CREATING_INTEGRATION = 'CREATE_DATA_SOURCE_CONFIG_WITHOUT_CREATING_INTEGRATION';
export const GENERATE_SECRET_KEY = 'GENERATE_SECRET_KEY';
export const GENERATE_LTI_CREDENTIALS = 'GENERATE_LTI_CREDENTIALS';
export const GET_GOOGLE_AUTH_URL = 'GET_GOOGLE_AUTH_URL';
export const REVOKE_ACCESS = 'REVOKE_ACCESS';
export const RELOAD_GOOGLE_CLASSROOM_COURSES = 'RELOAD_GOOGLE_CLASSROOM_COURSES';
export const GET_IS_LOADING_GOOGLE_CLASSROOM_COURSES_VALUE = 'GET_IS_LOADING_GOOGLE_CLASSROOM_COURSES_VALUE';
export const SET_GOOGLE_CLASSROOM_DATA_SOURCE_OPTIONS = 'SET_GOOGLE_CLASSROOM_DATA_SOURCE_OPTIONS';
export const TEST_CONNECTION = 'TEST_CONNECTION';
export const TEST_ETX_LDAP_CONNECTION = 'TEST_ETX_LDAP_CONNECTION';
export const BIND_DATA_SOURCE_TO_APPLICATION = 'BIND_DATA_SOURCE_TO_APPLICATION';
export const CREATE_INTEGRATION = 'CREATE_INTEGRATION';
export const SET_INTEGRATION = 'SET_INTEGRATION';
export const ASSIGN_INTEGRATION_TASK = 'ASSIGN_INTEGRATION_TASK';
export const ASSIGN_INTEGRATION_TASKS = 'ASSIGN_INTEGRATION_TASKS';
export const GET_INTEGRATION_DATA = 'GET_INTEGRATION_DATA';
export const GET_APPLICATION_INTEGRATION = 'GET_APPLICATION_INTEGRATION';
export const SAVE_INTEGRATION_TASK = 'SAVE_INTEGRATION_TASK';
export const SAVE_INTEGRATION_TASKS = 'SAVE_INTEGRATION_TASKS';
export const DELETE_INTEGRATION_TASKS = 'DELETE_INTEGRATION_TASKS';
export const INTEGRATION_TASKS_DELETED = 'INTEGRATION_TASKS_DELETED';
export const CHANGE_CSV_FILE_NAMES_OR_ADD_INTEGRATION_TASKS = 'CHANGE_CSV_FILE_NAMES_OR_ADD_INTEGRATION_TASKS';
export const REGENERATE_APPLICATION_PII_SHIELD_LEVEL = 'REGENERATE_APPLICATION_PII_SHIELD_LEVEL';
export const DELETE_APPLICATION = 'DELETE_APPLICATION';
export const SET_IS_DELETING_APPLICATION = 'SET_IS_DELETING_APPLICATION';
export const DELETE_DATA_SOURCE_CONFIG = 'DELETE_DATA_SOURCE_CONFIG';
export const INIT_INTEGRATION_STATE = 'INIT_INTEGRATION_STATE';
export const SET_INTEGRATION_STATE = 'SET_INTEGRATION_STATE';
export const SET_INTEGRATION_MODE = 'SET_INTEGRATION_MODE';
export const GET_INTEGRATION_ORG_MAPPING = 'GET_INTEGRATION_ORG_MAPPING';
export const SET_INTEGRATION_ORG_MAPPING = 'SET_INTEGRATION_ORG_MAPPING';
export const GET_INTEGRATION_RULES = 'GET_INTEGRATION_RULES';
export const SAVE_INTEGRATION_RULES = 'SAVE_INTEGRATION_RULES';
export const SET_INTEGRATION_RULES = 'SET_INTEGRATION_RULES';
export const SAVE_INTEGRATION_ORG_MAPPING = 'SAVE_INTEGRATION_ORG_MAPPING';
export const ASSIGN_INTEGRATION_ORGS_SELECTOR = 'ASSIGN_INTEGRATION_ORGS_SELECTOR';
export const ASSIGN_INTEGRATION_ORGS_MAPPING = 'ASSIGN_INTEGRATION_ORGS_MAPPING';
export const ASSIGN_ALL_MISSING_AS_NEW_INTEGRATION_ORG_MAPPING = 'ASSIGN_ALL_MISSING_AS_NEW_INTEGRATION_ORG_MAPPING';
export const ASSIGN_AUTO_INTEGRATION_ORG_MAPPING = 'ASSIGN_AUTO_INTEGRATION_ORG_MAPPING';
export const DELETE_INTEGRATION_ORG_MAPPING = 'DELETE_INTEGRATION_ORG_MAPPING';
export const INTEGRATION_ORG_MAPPING_DELETED = 'INTEGRATION_ORG_MAPPING_DELETED';
export const DELETE_INTEGRATION_ORG_MAPPING_LIST = 'DELETE_INTEGRATION_ORG_MAPPING_LIST';
export const DELETE_INTEGRATION_ORGS_MAPPING_ON_MAPPING_RULES_SAVING = 'DELETE_INTEGRATION_ORGS_MAPPING_ON_MAPPING_RULES_SAVING';
export const ASSIGN_INTEGRATION = 'ASSIGN_INTEGRATION';
export const ASSIGN_INTEGRATION_TASK_MAPPINGS = 'ASSIGN_INTEGRATION_TASK_MAPPINGS';
export const ASSIGN_DICTIONARY_BY_NAME = 'ASSIGN_DICTIONARY_BY_NAME';
export const RESET_GRADE_MAPPING = 'RESET_GRADE_MAPPING';
export const GET_DICTIONARY_BY_NAME = 'GET_DICTIONARY_BY_NAME';
export const SAVE_DICTIONARY_BY_NAME = 'SAVE_DICTIONARY_BY_NAME';
export const SAVE_QWIKLABS_DICTIONARY = 'SAVE_QWIKLABS_DICTIONARY';
export const GET_QWIKLABS_COURSES = 'GET_QWIKLABS_COURSES';
export const SET_QWIKLABS_COURSES = 'SET_QWIKLABS_COURSES';
export const EVICT_QWIKLABS_COURSES = 'EVICT_QWIKLABS_COURSES';
export const SAVE_SSO_APPLICATIONS_DICTIONARY = 'SAVE_SSO_APPLICATIONS_DICTIONARY';
export const GET_SSO_APPLICATIONS_DICTIONARY = 'GET_SSO_APPLICATIONS_DICTIONARY';
export const ASSIGN_INTEGRATION_PROCESS_CONFIG_ITEM = 'ASSIGN_INTEGRATION_PROCESS_CONFIG_ITEM';
export const ASSIGN_INTEGRATION_PROCESS_CONFIG_MODEL = 'ASSIGN_INTEGRATION_PROCESS_CONFIG_MODEL';
export const ASSIGN_APPLICATION_EXPIRATION_DATE = 'ASSIGN_APPLICATION_EXPIRATION_DATE';
export const SAVE_INTEGRATION_PROCESS_CONFIG = 'SAVE_INTEGRATION_PROCESS_CONFIG';
export const ASSIGN_MERGING_RULES = 'ASSIGN_MERGING_RULES';
export const GET_MERGING_RULES = 'GET_MERGING_RULES';
export const SAVE_MERGING_RULES = 'SAVE_MERGING_RULES';
export const SET_MERGING_RULES = 'SET_MERGING_RULES';
export const GET_MASTER_FIELDS = 'GET_MASTER_FIELDS';
export const SET_MASTER_FIELDS = 'SET_MASTER_FIELDS';
export const SAVE_AND_DELETE_MASTER_FIELDS = 'SAVE_AND_DELETE_MASTER_FIELDS';
export const ASSIGN_FILTRATIONS = 'ASSIGN_FILTRATIONS';
export const ASSIGN_SSO_FILTRATIONS = 'ASSIGN_SSO_FILTRATIONS';
export const ASSIGN_MAPPING_RULES = 'ASSIGN_MAPPING_RULES';
// export const CREATE_NEW_EDUTONE_ORGANIZATION = 'CREATE_NEW_EDUTONE_ORGANIZATION';
export const GET_PREDICATES_METADATA = 'GET_PREDICATES_METADATA';
export const SET_PREDICATES_METADATA = 'SET_PREDICATES_METADATA';
export const GET_APPLICATION_FEATURE_TOGGLES = 'GET_APPLICATION_FEATURE_TOGGLES';
export const SET_FEATURE_TOGGLES = 'SET_FEATURE_TOGGLES';
export const GET_INTEGRATION_FEATURE_TOGGLES = 'GET_INTEGRATION_FEATURE_TOGGLES';
export const GET_AUTO_PROVISIONING = 'GET_AUTO_PROVISIONING';
export const SAVE_AUTO_PROVISIONING = 'SAVE_AUTO_PROVISIONING';
export const SET_AUTO_PROVISIONING = 'SET_AUTO_PROVISIONING';
export const SET_PII_SHIELD_ENTITIES_ATTRIBUTES = 'SET_PII_SHIELD_ENTITIES_ATTRIBUTES';
export const PUBLISH = 'PUBLISH';
export const UNPUBLISH = 'UNPUBLISH';
export const GET_ORIGINAL_INTEGRATION = 'GET_ORIGINAL_INTEGRATION';
export const SET_IS_ORIGINAL_INTEGRATION = 'SET_IS_ORIGINAL_INTEGRATION';
export const APPLICATION_CLEAR_STATE = 'APPLICATION_CLEAR_STATE';
export const SET_IS_LOADING = 'SET_IS_LOADING';
export const SET_IS_SAVING_FTP_USER = 'SET_IS_SAVING_FTP_USER';
export const SAVE_SPINNER_INSTANCE_TO_ADD_APP_EFFECT = 'SAVE_SPINNER_INSTANCE_TO_ADD_APP_EFFECT';
export const GET_PRIVACY_POLICY_DOCUMENT_BY_NAME = 'GET_PRIVACY_POLICY_DOCUMENT_BY_NAME';
export const GET_ROSTER_ACCESS_PROGRESS = 'GET_ROSTER_ACCESS_PROGRESS';
export const SET_ROSTER_ACCESS_PROGRESS = 'SET_ROSTER_ACCESS_PROGRESS';
export const ACCEPT_PRIVACY_POLICY_DOCUMENT = 'ACCEPT_PRIVACY_POLICY_DOCUMENT';
export const GET_ACTUAL_PRIVACY_POLICY_DOCUMENT = 'GET_ACTUAL_PRIVACY_POLICY_DOCUMENT';
export const ASSIGN_ACTUAL_PRIVACY_POLICY_DOCUMENT = 'ASSIGN_ACTUAL_PRIVACY_POLICY_DOCUMENT';
export const SAVE_PRIVACY_POLICY_DOCUMENT = 'SAVE_PRIVACY_POLICY_DOCUMENT';
export const FAIL = 'FAIL';
export const SET_ERROR = 'SET_ERROR';

export class GetApplication implements Action {
    readonly type = GET_APPLICATION;
    constructor(public payload?: any) {}
}

export class AssignApplication implements Action {
    readonly type = ASSIGN_APPLICATION;
    constructor(public payload: any) {}
}

export class CreateOrUpdateApplication implements Action {
    readonly type = CREATE_OR_UPDATE_APPLICATION;
    constructor(public payload:
                    {
                        application: {name?: string; description?: string; url?: string; configurationStep?: number};
                        privacyPolicy?: any;
                        iconUploader?: FileUploader;
                        stopSpinner?: boolean;
                        publish?: boolean;
                    }
    ) {}
}

export class SetUserPermissions implements Action {
    readonly type = SET_USER_PERMISSIONS;
    constructor(public payload: UserPermissionModel) {}
}

export class GetDefaultApplications implements Action {
    readonly type = GET_DEFAULT_APPLICATIONS;
    constructor(public payload?: boolean) {}
}

export class SetDefaultApplications implements Action {
    readonly type = SET_DEFAULT_APPLICATIONS;
    constructor(public payload: Application[]) {}
}

export class SetProviderAllowedApplications implements Action {
    readonly type = SET_PROVIDER_ALLOWED_APPLICATIONS;
    constructor(public payload: Application[]) {}
}

export class SetVendorAllowedApplications implements Action {
    readonly type = SET_VENDOR_ALLOWED_APPLICATIONS;
    constructor(public payload: Application[]) {}
}

export class GetFTPConfig implements Action {
    readonly type = GET_FTP_CONFIG;
    constructor(public payload: string) {}
}

export class SetFTPConfig implements Action {
    readonly type = SET_FTP_CONFIG;

    constructor(public payload: FTPConfig) {}
}

export class AssignFTPConfig implements Action {
    readonly type = ASSIGN_FTP_CONFIG;
    constructor(public payload: {ftpUser: FTPUser; oldUsername: string}) {}
}

export class CreateFTPUser implements Action {
    readonly type = CREATE_FTP_USER;
    constructor(public payload: {ftpUser: FTPUser; providerGuid: string}) {}
}

export class EditFTPUser implements Action {
    readonly type = EDIT_FTP_USER;
    constructor(public payload: {ftpUser: FTPUser; oldUsername: string; providerGuid: string}) {}
}

export class DeleteFTPUser implements Action {
    readonly type = DELETE_FTP_USER;
    constructor(public payload: {username: string; providerGuid: string}) {}
}

export class GetRankOneDistrictList implements Action {
    readonly type = GET_RANK__ONE_DISTRICT_LIST;
}

export class AssignDataSourceConfig implements Action {
    readonly type = ASSIGN_DATA_SOURCE_CONFIG;
    constructor(public payload: any) {}
}

export class GetDataSourceConfig implements Action {
    readonly type = GET_DATA_SOURCE_CONFIG;
    constructor(public payload?: {dname: string; stopSpinner: boolean; createIntegration?: boolean}) {}
}

export class UpdateDataSourceConfig implements Action {
    readonly type = UPDATE_DATA_SOURCE_CONFIG;
    constructor(public payload?: {loadInterationOrgsMapping: boolean; publish: boolean; createIntegration?: boolean}) {}
}

export class AssignMappingRulesArchiveOU implements Action {
    readonly type = ASSIGN_MAPPING_RULES_ARCHIVE_OU;
    constructor(public payload: string) {}
}

export class SaveMappingRulesArchiveOU implements Action {
    readonly type = SAVE_MAPPING_RULES_ARCHIVE_OU;
    constructor(public payload: string) {}
}

export class CheckExistanceOfPowerSchoolPlugin implements Action {
    readonly type = CHECK_EXISTANCE_OF_POWER_SCHOOL_PLUGIN;
    constructor(public payload: number) {}
}

export class CreateDataSourceConfigWithoutCreatingIntegration implements Action {
    readonly type = CREATE_DATA_SOURCE_CONFIG_WITHOUT_CREATING_INTEGRATION;
    constructor(public payload?: {actionToDispatch: string; step: number}) {}
}

export class CreateDataSourceConfigAndIntegration implements Action {
    readonly type = CREATE_DATA_SOURCE_CONFIG_AND_INTEGRATION;
    constructor(public payload?: any) {}
}

export class CreateSharedPool implements Action {
    readonly type = CREATE_SHARED_POOL;
    constructor(public payload: SharedPoolResponseData) {
    }
}

export class GetSharedPoolsByApp implements Action {
    readonly type = GET_SHARED_POOLS_BY_APP;
    constructor(public payload: string) {}
}

export class GenerateSecretKey implements Action {
    readonly type = GENERATE_SECRET_KEY;
    constructor(public payload?: any) {}
}

export class GenerateLTICredentials implements Action {
    readonly type = GENERATE_LTI_CREDENTIALS;
    constructor(public payload?: any) {}
}

export class GetGoogleAuthUrl implements Action {
    readonly type = GET_GOOGLE_AUTH_URL;
}

export class RevokeAccess implements Action {
    readonly type = REVOKE_ACCESS;
    constructor(public payload?: number) {}
}

export class ReloadGoogleClassroomCourses implements Action {
    readonly type = RELOAD_GOOGLE_CLASSROOM_COURSES;
}

export class GetIsLoadingGoogleClassroomCoursesValue implements Action {
    readonly type = GET_IS_LOADING_GOOGLE_CLASSROOM_COURSES_VALUE;
}

export class SetGoogleClassroomDSOptions implements Action {
    readonly type = SET_GOOGLE_CLASSROOM_DATA_SOURCE_OPTIONS;
    constructor(public payload?: GoogleClassroomDataSourceOptions) {}
}

export class TestConnection implements Action {
    readonly type = TEST_CONNECTION;
    constructor(public payload: {
        dataSourceConfig: DataSourceConfig;
        isTestingConnectionSubject$: BehaviorSubject<boolean>;
        isTestingETXLDAPConnectionSubject$?: BehaviorSubject<boolean>;
        isValidConnection$: BehaviorSubject<boolean>;
        isValidETXLDAPConnection$: BehaviorSubject<boolean>;
        onTestConnectionForDebug$: BehaviorSubject<DataSourceConfig>;
        updateDataSourceConfig: boolean;
        actionToDispatch?: UpdateDataSourceConfig;
    }) {
    }
}

export class TestETXLDAPConnection implements Action {
    readonly type = TEST_ETX_LDAP_CONNECTION;

    constructor(public payload: {
        dataSourceConfig: DataSourceConfig;
        isTestingConnectionSubject$: BehaviorSubject<boolean>;
        isTestingETXLDAPConnectionSubject$?: BehaviorSubject<boolean>;
        isValidConnection$: BehaviorSubject<boolean>;
        isValidETXLDAPConnection$: BehaviorSubject<boolean>;
        onTestConnectionForDebug$: BehaviorSubject<DataSourceConfig>;
        updateDataSourceConfig: boolean;
        actionToDispatch?: UpdateDataSourceConfig;
    }) {
    }
}

export class BindDataSourceToApplication implements Action {
    readonly type = BIND_DATA_SOURCE_TO_APPLICATION;

    constructor(public payload: { dataSourceRef: string; dataSourceType: DataSourceType; modes: IntegrationMode[]; configurationStep?: number }) {
    }
}

export class CreateIntegration implements Action {
    readonly type = CREATE_INTEGRATION;

    constructor(public payload?: any) {
    }

    // constructor(public payload: DataSourceConfig) {}
}

export class SetIntegration implements Action {
    readonly type = SET_INTEGRATION;
    constructor(public payload: Integration) {}
}

export class AssignIntegrationTask implements Action {
    readonly type = ASSIGN_INTEGRATION_TASK;
    constructor(public payload: IntegrationTask) {}
}

export class AssignIntegrationTasks implements Action {
    readonly type = ASSIGN_INTEGRATION_TASKS;
    constructor(public payload: IntegrationTask[]) {}
}

export class GetIntegrationData implements Action {
    readonly type = GET_INTEGRATION_DATA;
    constructor(public payload: { ownerGuid: string; getInterationOrgsMapping?: boolean }) {
    }
}

export class GetApplicationIntegration implements Action {
    readonly type = GET_APPLICATION_INTEGRATION;
    constructor(public payload: {
        appGuid: string;
        ownerGuid: string;
        getInterationOrgsMapping?: boolean,
        withAttributes?: boolean,
        getIntegrationRulesData?: boolean
    }) {
        payload.withAttributes = (payload.withAttributes === false) ? payload.withAttributes : true;
        payload.getIntegrationRulesData = (payload.getIntegrationRulesData === false) ? payload.getIntegrationRulesData : true;
    }
}

export class SaveIntegrationTask implements Action {
    readonly type = SAVE_INTEGRATION_TASK;
    constructor(public payload: {task: IntegrationTask; lastTask: boolean; isAppCreated: boolean}) {}
}

export class SaveIntegrationTasks implements Action {
    readonly type = SAVE_INTEGRATION_TASKS;
    constructor(public payload: {
        isAppCreated: boolean;
        publish$: BehaviorSubject<boolean> | null;
        showMessage$?: BehaviorSubject<boolean>;
        tasks?: IntegrationTask[];
        errorMessage?: string;
        initiatorComponent: string;
    }) {}
}

export class DeleteIntegrationTasks implements Action {
    readonly type = DELETE_INTEGRATION_TASKS;
    constructor(public payload: IntegrationTask[]) {}
}

export class IntegrationTasksDeleted implements Action {
    readonly type = INTEGRATION_TASKS_DELETED;
    constructor(public payload: IntegrationTask[]) {}
}

export class ChangeCSVFileNamesOrAddIntegrationTasks implements Action {
    readonly type = CHANGE_CSV_FILE_NAMES_OR_ADD_INTEGRATION_TASKS;
    constructor(public payload: {integration: Integration; isAppCreated: boolean; publish: boolean}) {}
}

export class RegenerateApplicationPIIShieldLevel implements Action {
    readonly type = REGENERATE_APPLICATION_PII_SHIELD_LEVEL;
    constructor(public payload: {integrationId: string; applicationGuid: string}) {}
}

export class DeleteApplication implements Action {
    readonly type = DELETE_APPLICATION;
    constructor(public payload: string) {}
}

export class SetIsDeletingApplication implements Action {
    readonly type = SET_IS_DELETING_APPLICATION;
    constructor(public payload: boolean) {}
}

export class DeleteDataSourceConfig implements Action {
    readonly type = DELETE_DATA_SOURCE_CONFIG;
    constructor(public payload?: any) {}
}

export class InitIntegrationState implements Action {
    readonly type = INIT_INTEGRATION_STATE;
    constructor(public payload: boolean = null) {}
}

export class SetIntegrationState implements Action {
    readonly type = SET_INTEGRATION_STATE;
    constructor(public payload: IntegrationState) {}
}

export class SetIntegrationMode implements Action {
    readonly type = SET_INTEGRATION_MODE;
    constructor(public payload: IntegrationMode) {}
}

export class GetIntegrationOrgMapping implements Action {
    readonly type = GET_INTEGRATION_ORG_MAPPING;
    constructor(public payload?: {stopSpinner: boolean; showErrorMessage: boolean; messageAfterFinish: string}) {}
}

export class SetIntegrationOrgMapping implements Action {
    readonly type = SET_INTEGRATION_ORG_MAPPING;

    constructor(public payload: { organizationsMapping: OrganizationsMapping, blackboardViewOptionControl: FormControl }) {
    }
}

export class GetIntegrationRules implements Action {
    readonly type = GET_INTEGRATION_RULES;
    constructor(public payload: string) {}
}

export class SaveIntegrationRules implements Action {
    readonly type = SAVE_INTEGRATION_RULES;
    constructor(public payload: {
        integrationId: string;
        param: string;
        rules: EntityFilterModel[];
        message: string;
        publish$: BehaviorSubject<boolean> | null;
        saveResponseToStore?: boolean;
        showMessage$?: BehaviorSubject<boolean>;
        stopSpinner$?: BehaviorSubject<boolean>;
        institutionGuid?: string;
    }) {}
}

export class SetIntegrationRules implements Action {
    readonly type = SET_INTEGRATION_RULES;
    constructor(public payload: any) {}
}

export class SaveIntegrationOrgMapping implements Action {
    readonly type = SAVE_INTEGRATION_ORG_MAPPING;
    constructor(public payload?: {
        showSaveMessage: boolean;
        publish: boolean;
        savingMappingRulesOptions?: {
            publish$: BehaviorSubject<boolean>;
            mappingRules: MappingRule[];
            saveResponseToStore: boolean;
        };
    }) {}
}

export class AssignIntegrationOrgsSelector implements Action {
    readonly type = ASSIGN_INTEGRATION_ORGS_SELECTOR;
    constructor(public payload: {formControlValues: {}}) {}
}

export class AssignIntegrationOrgsMapping implements Action {
    readonly type = ASSIGN_INTEGRATION_ORGS_MAPPING;
    constructor(public payload: OrgMapping[]) {}
}

export class AssignAllMissingAsNewIntegrationOrgMapping implements Action {
    readonly type = ASSIGN_ALL_MISSING_AS_NEW_INTEGRATION_ORG_MAPPING;
    constructor(public payload: {createNewOrg: boolean; otherDS: string}) {}
}

export class AssignAutoIntegrationOrgMapping implements Action {
    readonly type = ASSIGN_AUTO_INTEGRATION_ORG_MAPPING;
    constructor(public payload: {isDistrictProvider: boolean; otherDS: string}) {}
}

export class DeleteIntegrationOrgMapping implements Action {
    readonly type = DELETE_INTEGRATION_ORG_MAPPING;

    constructor(public payload: { orgsMapping: OrgMapping[]; orgMapping: OrgMapping; blackboardViewOptionControl?: FormControl }) {
    }
}

export class IntegrationOrgMappingDeleted implements Action {
    readonly type = INTEGRATION_ORG_MAPPING_DELETED;

    constructor(public payload: { orgsMapping: OrgMapping[]; orgMapping: OrgMapping; blackboardViewOptionControl?: FormControl }) {
    }
}

export class DeleteIntegrationOrgMappingList implements Action {
    readonly type = DELETE_INTEGRATION_ORG_MAPPING_LIST;

    constructor(public payload: { orgsMappingDeleteList: OrgMapping[], blackboardViewOptionControl: FormControl }) {
    }
}

export class DeleteIntegrationOrgsMappingOnMappingRulesSaving implements Action {
    readonly type = DELETE_INTEGRATION_ORGS_MAPPING_ON_MAPPING_RULES_SAVING;

    constructor(public payload: {
        orgsMappingDeleteList: OrgMapping[];
        orgsMappingSaveList: OrgMapping[];
        savingMappingRulesOptions: { publish$: BehaviorSubject<boolean>; mappingRules: MappingRule[]; saveResponseToStore: boolean };
    }) {
    }
}

export class AssignIntegration  implements Action {
    readonly type = ASSIGN_INTEGRATION;
    constructor(public payload: Integration) {}
}

export class AssignIntegrationTaskMappings implements Action {
    readonly type = ASSIGN_INTEGRATION_TASK_MAPPINGS;
    constructor(public payload: {taskId: string; formControlValues: {}}) {}
}

export class AssignDictionaryByName implements Action {
    readonly type = ASSIGN_DICTIONARY_BY_NAME;
    constructor(public payload: {dictionaryName: string; dictionary: DictionaryModel}) {}
}

export class ResetGradeMapping implements Action {
    readonly type = RESET_GRADE_MAPPING;
}

export class GetDictionaryByName implements Action {
    readonly type = GET_DICTIONARY_BY_NAME;
    constructor(public payload: {
        dictionaryName: string;
        providerGuid: string;
        stepTitle: string;
    }) {}
}

export class SaveDictionaryByName implements Action {
    readonly type = SAVE_DICTIONARY_BY_NAME;
    constructor(public payload: {
        isAppCreated: boolean;
        publish$: BehaviorSubject<boolean> | null;
        dictionaryName: string;
        stepTitle: string;
        saveResponseToStore?: boolean;
    }) {}
}

export class SaveQwiklabsDictionary implements Action {
    readonly type = SAVE_QWIKLABS_DICTIONARY;
    constructor(public payload: {
        isAppCreated: boolean;
        dictionaryName: string;
        stepTitle: string;
        providerGuid?: string;
    }) {}
}

export class GetQwiklabsCourses implements Action {
    readonly type = GET_QWIKLABS_COURSES;
    constructor(public payload: string) {}
}

export class SetQwiklabsCourses implements Action {
    readonly type = SET_QWIKLABS_COURSES;
    constructor(public payload: QwiklabsCourse[]) {}
}

export class EvictQwiklabsCourses implements Action {
    readonly type = EVICT_QWIKLABS_COURSES;
}

export class SaveSSOApplicationsDictionary implements Action {
    readonly type = SAVE_SSO_APPLICATIONS_DICTIONARY;
    constructor(public payload: {
        isAppCreated: boolean;
        stepTitle: string;
    }) {}
}

export class GetSSOApplicationsDictionary implements Action {
    readonly type = GET_SSO_APPLICATIONS_DICTIONARY;
}

export class AssignIntegrationProcessConfigItem implements Action {
    readonly type = ASSIGN_INTEGRATION_PROCESS_CONFIG_ITEM;

    constructor(public payload: ProcessConfig) {}
}

export class AssignIntegrationProcessConfigModel implements Action {
    readonly type = ASSIGN_INTEGRATION_PROCESS_CONFIG_MODEL;

    constructor(public payload: ProcessConfig[]) {}
}

export class AssignApplicationExpirationDate implements Action {
    readonly type = ASSIGN_APPLICATION_EXPIRATION_DATE;

    constructor(public payload: Date) {}
}

export class SaveIntegrationProcessConfig implements Action {
    readonly type = SAVE_INTEGRATION_PROCESS_CONFIG;

    constructor(public payload: {processConfigModel?: ProcessConfig[]; expirationTs?: Date; isAppCreated?: boolean; publish?: boolean} ) {}
}

export class AssignMergingRules implements Action {
    readonly type = ASSIGN_MERGING_RULES;
    constructor(public payload: Integration) {}
}

export class GetMergingRules implements Action {
    readonly type = GET_MERGING_RULES;
}

export class SaveMergingRules implements Action {
    readonly type = SAVE_MERGING_RULES;
    constructor(public payload: {isAppCreated: boolean; saveResponseToStore?: boolean}) {}
}

export class SetMergingRules implements Action {
    readonly type = SET_MERGING_RULES;
    constructor(public payload: DomainOfUniqueness[]) {}
}

export class GetMasterFields implements Action {
    readonly type = GET_MASTER_FIELDS;
    constructor(public payload: string) {}
}

export class SetMasterFields implements Action {
    readonly type = SET_MASTER_FIELDS;
    constructor(public payload: MasterFieldsModel) {}
}

export class SaveAndDeleteMasterFields implements Action {
    readonly type = SAVE_AND_DELETE_MASTER_FIELDS;
    constructor(public payload: {
        saveMergingRuleList: MasterFieldsMergingRule[];
        deleteMergingRuleList: string[];
        mergingRulesWithoutChanges: MasterFieldsMergingRule[];
        savingMasterFieldsOptions?: {saveStep: boolean};
    }) {}
}

export class AssignFiltrations implements Action {
    readonly type = ASSIGN_FILTRATIONS;
    constructor(public payload: EntityFilterModel[]) {}
}

export class AssignSsoFiltrations implements Action {
    readonly type = ASSIGN_SSO_FILTRATIONS;
    constructor(public payload: EntityFilterModel[]) {}
}

export class AssignMappingRules implements Action {
    readonly type = ASSIGN_MAPPING_RULES;
    constructor(public payload: MappingRule[]) {}
}

// export class CreateNewEdutoneOrganization implements Action {
//     readonly type = CREATE_NEW_EDUTONE_ORGANIZATION;
//     constructor(public payload: {schoolName: string, districtProfile: DistrictProfileModel}) {}
// }

export class GetPredicatesMetadata implements Action {
    readonly type = GET_PREDICATES_METADATA;
}

export class SetPredicatesMetadata implements Action {
    readonly type = SET_PREDICATES_METADATA;

    constructor(public payload: MetadataModel[]) {
    }
}

export class GetApplicationFeatureToggles implements Action {
    readonly type = GET_APPLICATION_FEATURE_TOGGLES;

    constructor(public payload: { featureToggleLevel: FEATURE_TOGGLE_LEVEL, defaultApplicationGuid: string }) {
    }
}

export class SetFeatureToggles implements Action {
    readonly type = SET_FEATURE_TOGGLES;

    constructor(public payload: { application?: FeatureToggleModel[], integration?: FeatureToggleModel[] }) {
    }
}

export class GetIntegrationFeatureToggles implements Action {
    readonly type = GET_INTEGRATION_FEATURE_TOGGLES;

    constructor(public payload: { integrationId: string, defaultAppGuid: string }) {
    }
}

export class GetAutoProvisioning implements Action {
    readonly type = GET_AUTO_PROVISIONING;

    constructor(public payload: string) {
    }
}

export class SaveAutoProvisioning implements Action {
    readonly type = SAVE_AUTO_PROVISIONING;

    constructor(public payload: Webhook) {
    }
}

export class SetAutoProvisioning implements Action {
    readonly type = SET_AUTO_PROVISIONING;

    constructor(public payload: Webhook) {
    }
}

export class SetPIIShieldEntitiesAttributes implements Action {
    readonly type = SET_PII_SHIELD_ENTITIES_ATTRIBUTES;

    constructor(public payload: PIIShieldEntityAttributes[]) {
    }
}

export class Publish implements Action {
    readonly type = PUBLISH;

    constructor(public payload: ViewContainerRef) {
    }
}

export class UnPublish implements Action {
    readonly type = UNPUBLISH;

    constructor(public payload?: any) {
    }
}

export class GetOriginalIntegration implements Action {
    readonly type = GET_ORIGINAL_INTEGRATION;
    constructor(public payload: string) {}
}

export class SetIsOriginalIntegration implements Action {
    readonly type = SET_IS_ORIGINAL_INTEGRATION;
    constructor(public payload: boolean) {}
}

export class ApplicationClearState implements Action {
    readonly type = APPLICATION_CLEAR_STATE;
    constructor(public payload?: any) {}
}

export class SetIsLoading implements Action {
    readonly type = SET_IS_LOADING;
    constructor(public payload: boolean) {}
}

export class SetIsSavingFTPUser implements Action {
    readonly type = SET_IS_SAVING_FTP_USER;
    constructor(public payload: boolean) {}
}

export class SavePrivacyPolicyDocument implements Action {
    readonly type = SAVE_PRIVACY_POLICY_DOCUMENT;
    constructor(public payload: SavePolicyModel) {}
}

export class AcceptPrivacyPolicyDocument implements Action {
    readonly type = ACCEPT_PRIVACY_POLICY_DOCUMENT;
    constructor(public payload?: any) {}
}

export class GetActualPrivacyPolicyDocument implements Action {
    readonly type = GET_ACTUAL_PRIVACY_POLICY_DOCUMENT;
    constructor(public payload: { defaultApplication: Application, integrationMode?: IntegrationMode }) {
    }
}

export class AssignActualPrivacyPolicyDocument implements Action {
    readonly type = ASSIGN_ACTUAL_PRIVACY_POLICY_DOCUMENT;
    constructor(public payload: Claim) {}
}

export class SaveSpinnerInstanceToAddAppEffect implements Action {
    readonly type = SAVE_SPINNER_INSTANCE_TO_ADD_APP_EFFECT;
    constructor(public payload: Spinner) {}
}

export class GetRosterAccessProgress implements Action {
    readonly type = GET_ROSTER_ACCESS_PROGRESS;
    constructor(public payload: string) {}
}

export class SetRosterAccessProgress implements Action {
    readonly type = SET_ROSTER_ACCESS_PROGRESS;
    constructor(public payload: RosterAccessProgress) {}
}

export class Fail implements Action {
    readonly type = FAIL;
    constructor(public payload: {error: Error; doNotStopSpinner?: boolean}) {}
}

export class SetError implements Action {
    readonly type = SET_ERROR;
    constructor(public payload: any) {}
}

export type ApplicationSettingsActions =
    GetApplication |
    AssignApplication |
    CreateOrUpdateApplication |
    SetUserPermissions |
    GetDefaultApplications |
    SetDefaultApplications |
    SetProviderAllowedApplications |
    SetVendorAllowedApplications |
    GetFTPConfig |
    SetFTPConfig |
    AssignFTPConfig |
    CreateFTPUser |
    EditFTPUser |
    DeleteFTPUser |
    GetRankOneDistrictList |
    AssignDataSourceConfig |
    GetDataSourceConfig |
    UpdateDataSourceConfig |
    AssignMappingRulesArchiveOU |
    SaveMappingRulesArchiveOU |
    CheckExistanceOfPowerSchoolPlugin |
    CreateDataSourceConfigWithoutCreatingIntegration |
    CreateDataSourceConfigAndIntegration |
    CreateSharedPool |
    GetSharedPoolsByApp |
    GenerateSecretKey |
    GenerateLTICredentials |
    GetGoogleAuthUrl |
    RevokeAccess |
    ReloadGoogleClassroomCourses |
    GetIsLoadingGoogleClassroomCoursesValue |
    SetGoogleClassroomDSOptions |
    TestConnection |
    TestETXLDAPConnection |
    BindDataSourceToApplication |
    CreateIntegration |
    SetIntegration |
    AssignIntegrationTask |
    AssignIntegrationTasks |
    GetIntegrationData |
    GetApplicationIntegration |
    SaveIntegrationTask |
    SaveIntegrationTasks |
    DeleteIntegrationTasks |
    IntegrationTasksDeleted |
    ChangeCSVFileNamesOrAddIntegrationTasks |
    RegenerateApplicationPIIShieldLevel |
    DeleteApplication |
    SetIsDeletingApplication |
    DeleteDataSourceConfig |
    InitIntegrationState |
    SetIntegrationState |
    SetIntegrationMode |
    GetIntegrationOrgMapping |
    SetIntegrationOrgMapping |
    GetIntegrationRules |
    SaveIntegrationRules |
    SetIntegrationRules |
    SaveIntegrationOrgMapping |
    AssignIntegrationOrgsSelector |
    AssignIntegrationOrgsMapping |
    AssignAllMissingAsNewIntegrationOrgMapping |
    AssignAutoIntegrationOrgMapping |
    DeleteIntegrationOrgMapping |
    IntegrationOrgMappingDeleted |
    DeleteIntegrationOrgMappingList |
    DeleteIntegrationOrgsMappingOnMappingRulesSaving |
    AssignIntegration |
    AssignIntegrationTaskMappings |
    AssignDictionaryByName |
    ResetGradeMapping |
    GetDictionaryByName |
    SaveDictionaryByName |
    SaveQwiklabsDictionary |
    GetQwiklabsCourses |
    SetQwiklabsCourses |
    EvictQwiklabsCourses |
    SaveSSOApplicationsDictionary |
    GetSSOApplicationsDictionary |
    AssignIntegrationProcessConfigItem |
    AssignIntegrationProcessConfigModel |
    AssignApplicationExpirationDate |
    SaveIntegrationProcessConfig |
    AssignMergingRules |
    GetMergingRules |
    SaveMergingRules |
    SetMergingRules |
    GetMasterFields |
    SetMasterFields |
    SaveAndDeleteMasterFields |
    AssignFiltrations |
    AssignSsoFiltrations |
    AssignMappingRules |
    // CreateNewEdutoneOrganization |
    GetPredicatesMetadata |
    SetPredicatesMetadata |
    GetApplicationFeatureToggles |
    SetFeatureToggles |
    GetIntegrationFeatureToggles |
    GetAutoProvisioning |
    SaveAutoProvisioning |
    SetAutoProvisioning |
    SetPIIShieldEntitiesAttributes |
    Publish |
    UnPublish |
    GetOriginalIntegration |
    SetIsOriginalIntegration |
    ApplicationClearState |
    SetIsLoading |
    SetIsSavingFTPUser |
    AcceptPrivacyPolicyDocument |
    GetActualPrivacyPolicyDocument |
    AssignActualPrivacyPolicyDocument |
    SavePrivacyPolicyDocument |
    SaveSpinnerInstanceToAddAppEffect |
    GetRosterAccessProgress |
    SetRosterAccessProgress |
    Fail |
    SetError;
